import React from "react";
import { Grid, Typography } from "@material-ui/core";
import CommonPage from "@icarius-common/commonPage";
import SuggestionIcon from "./suggestionIcon";
import QuestionsIcon from "./questionsIcon";
import ComplaintsIcon from "./complaintsIcon";
import ReportsIcon from "./reportsIcon";
import { getLocalizedString } from "@icarius-localization/strings";

const HomeScreen = ({ indicators, isLoading, handleSelectCommunication, showComplaints }) => {
    return (
        <CommonPage
            isNotGridPage
            isLoading={isLoading}
        >
            <Grid container item xs={12} style={{ padding: "0px 20px", marginTop: 25 }}>
                <Grid item xs={12}>
                    <Typography className="whiteText" variant="h5">
                        {getLocalizedString("welcomeToCommunicationChannel")}
                    </Typography>
                </Grid>
                <Grid container item xs={12} style={{ marginTop: 20 }}>
                    <Typography className="whiteText" variant="subtitle1">
                        {showComplaints ?
                            getLocalizedString("youCanSendUsYourQueriesMakeClaimsContributeSuggestionsAndReportComplaints") :
                            getLocalizedString("youCanSendUsYourQueriesMakeClaimsContributeSuggestions")}
                    </Typography>
                </Grid>
                <Grid container item xs={12} style={{ display: "flex", justifyContent: "center", margin: 50 }}>
                    <Grid item xs={12} sm={6} md={2} style={{ cursor: "pointer", display: "flex", position: "relative", flexDirection: "column", alignItems: "center" }}
                        onClick={() => handleSelectCommunication("C")}>
                        <QuestionsIcon />
                        {
                            parseInt(indicators?.pendingQueries) > 0 &&
                            <div className="easyAccessCounter">
                                <Typography style={{ color: 'var(--secondaryBackgroundColor)', fontSize: "14px", fontWeight: "500" }}>
                                    {indicators?.pendingQueries > 9 ? "+9" : indicators?.pendingQueries}
                                </Typography>
                            </div>
                        }
                        <Typography className="whiteText" variant="subtitle1" style={{ fontWeight: 700, fontSize: 21 }}>
                            {`${getLocalizedString("queries")} (${indicators?.totalQueries || 0})`}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} style={{ cursor: "pointer", display: "flex", flexDirection: "column", position: "relative", alignItems: "center" }}
                        onClick={() => handleSelectCommunication("R")}>
                        <ComplaintsIcon />
                        {
                            parseInt(indicators?.pendingClaims) > 0 &&
                            <div className="easyAccessCounter">
                                <Typography style={{ color: 'var(--secondaryBackgroundColor)', fontSize: "14px", fontWeight: "500" }}>
                                    {indicators?.pendingClaims > 9 ? "+9" : indicators?.pendingClaims}
                                </Typography>
                            </div>
                        }
                        <Typography className="whiteText" variant="subtitle1" style={{ fontWeight: 700, fontSize: 21 }}>
                            {`${getLocalizedString("complaints")} (${indicators?.totalClaims || 0})`}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} style={{ cursor: "pointer", display: "flex", flexDirection: "column", position: "relative", alignItems: "center" }}
                        onClick={() => handleSelectCommunication("S")}>
                        <SuggestionIcon />
                        {
                            parseInt(indicators?.pendingSuggestions) > 0 &&
                            <div className="easyAccessCounter">
                                <Typography style={{ color: 'var(--secondaryBackgroundColor)', fontSize: "14px", fontWeight: "500" }}>
                                    {indicators?.pendingSuggestions > 9 ? "+9" : indicators?.pendingSuggestions}
                                </Typography>
                            </div>
                        }
                        <Typography className="whiteText" variant="subtitle1" style={{ fontWeight: 700, fontSize: 21 }}>
                            {`${getLocalizedString("suggestions")} (${indicators?.totalSuggestions || 0})`}
                        </Typography>
                    </Grid>
                    {
                        showComplaints &&
                        <Grid item xs={12} sm={6} md={2} style={{ cursor: "pointer", display: "flex", flexDirection: "column", position: "relative", alignItems: "center" }}
                            onClick={() => handleSelectCommunication("D")}>
                            <ReportsIcon />
                            {
                                parseInt(indicators?.pendingComplaints) > 0 &&
                                <div className="easyAccessCounter">
                                    <Typography style={{ color: 'var(--secondaryBackgroundColor)', fontSize: "14px", fontWeight: "500" }}>
                                        {indicators?.pendingComplaints > 9 ? "+9" : indicators?.pendingComplaints}
                                    </Typography>
                                </div>
                            }
                            <Typography className="whiteText" variant="subtitle1" style={{ fontWeight: 700, fontSize: 21 }}>
                                {`${getLocalizedString("reports")} (${indicators?.totalComplaints || 0})`}
                            </Typography>
                        </Grid>
                    }
                </Grid>
                <Grid container item xs={12}>
                    {
                        showComplaints && <Grid item xs={12}>
                            <Typography className="whiteText" variant="subtitle1">
                                {getLocalizedString("complaintsLine1Part1")}<span style={{ color: "red" }}>{getLocalizedString("complaintsLine1Part2")}</span>{getLocalizedString("complaintsLine1Part3")}
                            </Typography>
                        </Grid>
                    }
                    {
                        showComplaints && <Grid item xs={12} style={{ margin: "30px 0px" }}>
                            <Typography className="whiteText" variant="subtitle1">
                                {getLocalizedString("complaintsLine2")}
                            </Typography>
                        </Grid>
                    }
                    {
                        showComplaints && <Grid item xs={12}>
                            <Typography className="whiteText" variant="subtitle1">
                                {getLocalizedString("complaintsLine3")}
                            </Typography>
                        </Grid>
                    }
                    <Grid item xs={12} style={{ margin: "30px 0px" }}>
                        <Typography className="whiteText" variant="subtitle1" style={{ textAlign: "end", fontWeight: 700 }}>
                            {getLocalizedString("complaintsLine4")}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </CommonPage>
    )
}

export default HomeScreen;